/**
 * @jsxRuntime classic
 * @jsx jsx
 */

import { useIntl } from 'react-intl';

import { cssMap, jsx } from '@atlaskit/css';
import { Box, Stack, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

import { messages } from './ManageMemoryEditsSubscreen.messages';

const styles = cssMap({
	container: {
		display: 'flex',
		flexDirection: 'column',
		width: '100%',
		border: `${token('border.width')} solid ${token('color.border')}`,
		borderRadius: token('radius.xlarge'),
		overflow: 'hidden',
	},
	emptyState: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		flex: '1 1 0%',
		minHeight: '200px',
		paddingBlock: token('space.400'),
		paddingInline: token('space.300'),
		textAlign: 'center',
	},
});

export const EmptyState = (): JSX.Element => {
	const { formatMessage } = useIntl();
	return (
		<Stack xcss={styles.container} space="space.0">
			<Box xcss={styles.emptyState}>
				<Text as="p" color="color.text.subtle" size="medium">
					{formatMessage(messages.emptyStateMessage)}
				</Text>
			</Box>
		</Stack>
	);
};
